export default __webpack_public_path__ + "static/media/pic2.297fbcd5.jpg";